<template>
  <div class="print-results">
    <el-table class="table-striped wrap-whole-words" id="printMyTasks"
              :data="tableData"
              border>
      <el-table-column
        :min-width="150"
        prop="name"
        label="Name">
      </el-table-column>
      <el-table-column
        :min-width="150"
        prop="assignee"
        label="Assignee">
      </el-table-column>
      <el-table-column
        label="Due Date"
        :min-width="150">
        <template slot-scope="props">
          {{ props.row.dueDate | formatDate}}
        </template>
      </el-table-column>
      <el-table-column v-for="column in tableColumns"
                       :key="column.label"
                       :min-width="column.minWidth"
                       :prop="column.prop"
                       :sortable="column.sortable"
                       :label="column.label">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {Table, TableColumn} from 'element-ui'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      Table,
      TableColumn
    },
    computed: {
      ...mapGetters({
        tableData: 'tasks/myTasks/all'
      })
    },
    data() {
      return {
        tableColumns: [
          {
            prop: 'status',
            label: 'Status',
            minWidth: 120,
            sortable: true
          },
          {
            prop: 'priority',
            label: 'Task Priority',
            minWidth: 180,
            sortable: true
          },
          {
            prop: 'project.name',
            label: 'Project Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: 'project.address.streetNumber',
            label: 'Street Number',
            minWidth: 190,
            sortable: true
          },
          {
            prop: 'project.address.streetName',
            label: 'Street Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: 'project.address.city',
            label: 'City',
            minWidth: 180,
            sortable: true
          },
          {
            prop: 'job.name',
            label: 'Job Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: 'job.builder.name',
            label: 'Builder Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: 'job.client.name',
            label: 'Client Name',
            minWidth: 180,
            sortable: true
          },
          {
            prop: 'job.priority',
            label: 'Job Priority',
            minWidth: 180,
            sortable: true
          }
        ]
      }
    }
  }
</script>
